export var FULLSCREEN_FILE_VIEWER_MAX_ZOOM = 5;
export var FULLSCREEN_FILE_VIEWER_MIN_ZOOM = 1;
export var FULLSCREEN_FILE_ACTIONS_HEIGHT = 75;
